export default __webpack_public_path__ + "static/media/whoosh.9325ef0a.mp3";